import React, { useContext, useEffect, useState } from "react";
import propTypes from "prop-types";

import { api, BookingHistory } from "../../../../logic/api";

import flex from "../../../../styles/flex";
import styles from "./styles";

import { formatString, getFileUrl } from "../../../../utility/utils";
import { SessionContext } from "../../../../utility/useSession";
import { useDate } from "../../../../utility/useDate";

import { ProgressView } from "../../../../components/notifications/progress/ProgressView";
import { useTranslation } from "react-i18next";
import { useFormatter } from "../../../../utility/useFormatter";

const BookingHistoryTable: React.FunctionComponent<{
    bookingId: number,

}> = (props) => {
    const session = useContext(SessionContext);
    const { toFormattedDateTimeString } = useDate();
    const [historyItems, setHistoryItems] = useState<BookingHistory[]>([]);
    const { t } = useTranslation();
    const getBookingHistory = api.hooks.booking.getBookingHistory();

    useEffect(() => {
        getBookingHistory.send(session.current.context, {
            bookingId: props.bookingId
        });
    }, [props.bookingId]);

    useEffect(() => {
        if (getBookingHistory.data != null) {
            setHistoryItems(getBookingHistory.data);
        } else {
            setHistoryItems([]);
        }
    }, [getBookingHistory.data]);

    const formatters = useFormatter();

    return <ProgressView status={getBookingHistory.status}>
        {
            historyItems.length == 0 ? (
                <div>{t("input.validations.noBookingHistory")}</div>
            ) : (
                <div>{historyItems.map((historyItem, i) => {
                    const created = toFormattedDateTimeString(new Date(historyItem.createDate));
                    const bookingHistoryText = formatters.bookingHistoryFormatter(historyItem);
                    if (bookingHistoryText === null) return null;

                    return <div key={i} style={flex.flexRows}>
                        <div style={{ ...flex.flexAuto, minWidth: "9em" }}><div style={styles.cell}>{created}</div></div>

                        <div style={flex.flexFill}>
                            <div style={styles.cell}>
                                {formatString(bookingHistoryText)}
                            </div>
                        </div>
                        {
                            (historyItem.photoName != null && historyItem.photoName != "") && (
                                <div style={flex.flexAuto}><div style={styles.cell}><a rel="noreferrer" target="_blank" href={getFileUrl(session, historyItem.photoName)}>{t("input.labels.viewAttachment")}</a></div></div>
                            )
                        }
                    </div>
                })}</div>
            )
        }

    </ProgressView>
}

BookingHistoryTable.propTypes = {
    bookingId: propTypes.number.isRequired,
}

export default BookingHistoryTable;
